import { FreeformSeat, JobStageInterviewSeatType, LinkedSeat, ModuleSeat } from 'src/generated/mloop-graphql';

export type AttributeMap = {
  [key: string]: string[];
};

export const TRAINEE_REQUIREMENT = {
  NONE: 'NONE',
  SHADOW: 'SHADOW',
  REVERSE_SHADOW: 'REVERSE_SHADOW',
  ANY: 'ANY',
} as const;

export type TraineeRequirement = (typeof TRAINEE_REQUIREMENT)[keyof typeof TRAINEE_REQUIREMENT];

export const TRAINEE_SCHEDULING_STRATEGY = {
  IS_AVAILABLE: 'IS_AVAILABLE',
  REQUIRED: 'REQUIRED',
} as const;

export type TraineeSchedulingStrategy = (typeof TRAINEE_SCHEDULING_STRATEGY)[keyof typeof TRAINEE_SCHEDULING_STRATEGY];

export type JobStageInterviewSeat = {
  id: string;
  jobStageInterviewId: string;
  index: number;
  type: JobStageInterviewSeatType;
  interviewId?: string; // interview module to which this seat points to.
  interviewSeatId?: string; // will be available for linked interview.
  employeeIds?: string[]; // list of employees for freeform seats.

  // local fields
  attributeMap?: AttributeMap;
  shadowAttributeMap?: AttributeMap;
  reverseShadowAttributeMap?: AttributeMap;
  traineeRequirement?: TraineeRequirement;
  traineeSchedulingStrategy?: TraineeSchedulingStrategy;
  selectedTrainedInterviewerIds?: string[];
  selectedReverseShadowInterviewerIds?: string[];
  selectedShadowInterviewerIds?: string[];

  freeformSeat?: FreeformSeat;
  moduleSeat?: ModuleSeat;
  linkedSeat?: LinkedSeat;
};
